var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{staticClass:"voice-formatting-picker",attrs:{"compact":"","icon":"add","label":"Voice Formatting","disabled":""},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }